import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Button,
  Table,
  Spinner,
  Alert,
  Container,
} from "react-bootstrap";
import * as XLSX from "xlsx";
import JSZip from "jszip";
import {
  sendText,
  sendDocument,
  checkWhatsAppNumber,
} from "../whatsapp-channels/services/api";
import { sendDocumentByEmail } from "../whatsapp-channels/services/mail";
export default function Finance() {
  const [step, setStep] = useState(1);
  const [sendWhatsapp, setSendWhatsapp] = useState(false);
  const [sendEmail, setSendEmail] = useState(true);
  const [excelData, setExcelData] = useState([]);
  const [pdfFiles, setPdfFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendingStatus, setSendingStatus] = useState({});
  const [error, setError] = useState("");
  const defaultMessage = `Sr Cliente. 
Informamos que o seu boleto está vencendo e para sua comodidade segue por aqui a segunda via.`;
  const handleExcelUpload = async (e) => {
    setLoading(true);
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const workbook = XLSX.read(event.target.result, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(sheet);
        setExcelData(data);
        setStep(2);
      } catch (err) {
        setError("Erro ao processar arquivo Excel");
      }
      setLoading(false);
    };

    reader.readAsBinaryString(file);
  };

  const handleZipUpload = async (e) => {
    setLoading(true);
    const file = e.target.files[0];
    const zip = new JSZip();

    try {
      const zipContents = await zip.loadAsync(file);
      const pdfDict = [];

      for (const [fileName, fileData] of Object.entries(zipContents.files)) {
        if (fileName.endsWith(".pdf") || fileName.endsWith(".PDF")) {
          const pdfName = fileName.replace(".pdf", "");
          pdfDict.push({ name: pdfName, file: await fileData.async("blob") });
        }
      }
      console.log("pdfDict", pdfDict);
      setPdfFiles(pdfDict);
      setStep(3);
    } catch (err) {
      setError("Erro ao processar arquivo ZIP");
    }
    setLoading(false);
  };

  useEffect(() => {
    console.log(pdfFiles);
  }, [pdfFiles]);

  const findBoleto = (number) => {
    const boletoEncontrado = pdfFiles.find((boleto) =>
      boleto.name.includes(number)
    );
    console.log(`Encontrando boleto: ${boletoEncontrado}`);
    return boletoEncontrado;
  };
  const sendInvoice = async (row, index) => {
    setLoading(true);
    setSendingStatus((prev) => ({ ...prev, [index]: "sending" }));

    try {
      // Simular envio
      await new Promise((resolve) => setTimeout(resolve, index * 1000));
      const boleto = findBoleto(row.BOLETO);

      if (row.TELEFONE && row.TELEFONE.trim() !== "" && sendWhatsapp) {
        // const telefone = "5541996147929"; //row.TELEFONE.replace(/[^0-9]/g, "");
        const telefone = `55${row.TELEFONE.replace(/[^0-9]/g, "")}`;

        const whatsappNumber = await checkWhatsAppNumber(
          "PAODIARIO_FINANCE",
          telefone
        );

        if (!whatsappNumber) {
          setSendingStatus((prev) => ({ ...prev, [index]: "error" }));
          return;
        }
        console.log(`Enviando para WhatsApp: ${whatsappNumber}`);
        await sendText("PAODIARIO_FINANCE", whatsappNumber, defaultMessage);
        await sendDocument(
          "PAODIARIO_FINANCE",
          whatsappNumber,
          "boleto.pdf",
          boleto.file
        );
        // Implementar lógica de envio WhatsApp
        console.log(`Enviando para WhatsApp: ${whatsappNumber}`);
      }
      if (row.EMAIL && row.EMAIL.trim() !== "" && sendEmail) {
        await sendDocumentByEmail(row.EMAIL, "boleto.pdf", boleto.file);
        // await sendDocumentByEmail(row.EMAIL, "boleto.pdf", boleto.file);

        // Implementar lógica de envio Email
        console.log(`Enviando para Email: ${row.EMAIL}`);
      }

      setSendingStatus((prev) => ({ ...prev, [index]: "sent" }));
    } catch (err) {
      setSendingStatus((prev) => ({ ...prev, [index]: "error" }));
    }

    setLoading(false);
  };

  return (
    <Container fluid>
      <Card className="mt-4 container mb-4">
        <Card.Body>
          <Card.Title className="fw-bold text-center mb-4">
            Send boletos to customers
          </Card.Title>

          {error && <Alert variant="danger">{error}</Alert>}

          {step === 1 && (
            <Form.Group className="mb-3">
              <Form.Label>
                <b>1.</b> Upload Excel File
              </Form.Label>
              <Form.Control
                type="file"
                accept=".xlsx,.xls"
                onChange={handleExcelUpload}
              />
            </Form.Group>
          )}
          {step === 2 && (
            <Form.Group className="mb-3">
              <Form.Label>
                <b>2.</b> Upload ZIP com PDFs
              </Form.Label>
              <Form.Control
                type="file"
                accept=".zip"
                onChange={handleZipUpload}
              />
            </Form.Group>
          )}

          {step === 3 && (
            <div className="">
              <div className="row mb-4">
                <div
                  className="col"
                  style={{
                    textAlign: "left",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Form.Check
                    type="switch"
                    id="whatsapp-switch"
                    label="Enviar por WhatsApp"
                    className="me-5"
                    checked={sendWhatsapp}
                    onChange={(e) => setSendWhatsapp(e.target.checked)}
                  />

                  <Form.Check
                    type="switch"
                    id="email-switch"
                    label="Enviar por Email"
                    checked={sendEmail}
                    onChange={(e) => setSendEmail(e.target.checked)}
                  />
                </div>
              </div>
              <Button
                variant="primary"
                onClick={() => {
                  excelData.forEach((row, index) => {
                    sendInvoice(row, index);
                  });
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" /> Processando...
                  </>
                ) : (
                  "Enviar Documentos"
                )}
              </Button>
            </div>
          )}
        </Card.Body>
      </Card>

      {step >= 2 && excelData.length > 0 && (
        <>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                {Object.keys(excelData[0]).map((key) => (
                  <th key={key}>{key === "__EMPTY" ? "" : key}</th>
                ))}
                <th>Status</th>
                <th>PDF</th>
              </tr>
            </thead>
            <tbody>
              {excelData.map((row, index) => {
                const maxColumns = Object.keys(excelData[0]).length;
                const currentColumns = Object.keys(row).length;
                const emptyColumns = maxColumns - currentColumns;
                const boleto = findBoleto(row.BOLETO);
                return (
                  <tr key={index}>
                    {Object.values(row).map((value, i) => (
                      <td key={i}>{value || ""}</td>
                    ))}
                    {[...Array(emptyColumns)].map((_, i) => (
                      <td key={`empty-${i}`}></td>
                    ))}
                    <td>
                      {sendingStatus[index] === "sent" && "✅"}
                      {sendingStatus[index] === "error" && "❌"}
                      {sendingStatus[index] === "sending" && (
                        <Spinner animation="border" size="sm" />
                      )}
                    </td>
                    <td>{boleto && <span>{boleto.name}</span>}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </>
      )}
    </Container>
  );
}
